var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"interact-smart-index-detail"},[_c('el-main',{staticClass:"interact-smart-index-wrap"},[_c('editQues',{tag:"component",attrs:{"saveName":_vm.saveName,"name":'editQues'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }